import type { SettingConfigSiteInfo } from './type';

/* 상망 */
export const productionPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://www.pandalive.co.kr',
  BASE_URL: 'https://www.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  CACHE_API_URL: 'cache-api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  STATS_URL: 'https://stats.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mProductionPandatv: SettingConfigSiteInfo = {
  PC_URL: 'https://www.pandalive.co.kr',
  BASE_URL: 'https://m.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  CACHE_API_URL: 'cache-api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  STATS_URL: 'https://stats.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

/** fanza */

export const productionFanza: SettingConfigSiteInfo = {
  PC_URL: 'https://pandalive.co.jp',
  BASE_URL: 'https://pandalive.co.jp',
  API_URL: 'gapi.pandalive.co.jp',
  CACHE_API_URL: 'cache-gapi.pandalive.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.pandalive.co.jp/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

export const mProductionFanza: SettingConfigSiteInfo = {
  PC_URL: 'https://pandalive.co.jp',
  BASE_URL: 'https://m.pandalive.co.jp',
  API_URL: 'gapi.pandalive.co.jp',
  CACHE_API_URL: 'cache-gapi.pandalive.co.jp',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.pandalive.co.jp/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_MOBILE_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};

// sales url is https://sales.pandalive.co.kr

export const productionSales: SettingConfigSiteInfo = {
  PC_URL: 'https://sales.pandalive.co.kr',
  BASE_URL: 'https://sales.pandalive.co.kr',
  API_URL: 'api.pandalive.co.kr',
  EVENT_URL: 'https://events.pandalive.co.kr',
  S3_BUCKET_URL: 'https://cdn.pandalive.co.kr/public',
  PANDA_CHAT_SOCKET: 'wss://chat-ws.neolive.kr/connection/websocket',
  SENTRY_DSN: process.env.SENTRY_DSN,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
};
